import parsePathAndQueryParams from './parsePathAndQueryParams';
import parseQueryString from './parseQueryString';
import stringifyQueryParams from './stringifyQueryParams';

const DEFAULT_QUERY_PARAM_WHITELIST = ['utm_source', 'utm_medium', 'utm_campaign', 'itc'];

/**
 * Return path with query parameters we want to persist
 *
 * @param fullPath - The full path including query params
 * @param additionalWhitelist - A list to append to the default query param whitelist
 * @returns {string} The path with only whitelisted query params
 */
export default function getPathWithPersistedQueryParams(
  fullPath: string,
  additionalWhitelist: Array<string> = [],
): string {
  const locationObj = parsePathAndQueryParams(fullPath);
  const { path, queryParams } = locationObj;

  // list of query params we want to persist as the user navigates
  const queryParamWhitelist = DEFAULT_QUERY_PARAM_WHITELIST.concat(additionalWhitelist);

  const queryParamObj = parseQueryString(queryParams);

  // loop through query params and remove those not in the whitelist
  for (const queryParam in queryParamObj) {
    if (queryParamWhitelist.indexOf(queryParam) < 0) {
      delete queryParamObj[queryParam];
    }
  }

  // stringify and re-parse to normalize the output
  const queryParamsString = stringifyQueryParams(queryParamObj);
  const tempObj = parsePathAndQueryParams(`${path}${queryParamsString}`);

  // parsePathAndQueryParams returns queryParams without the '?' prefix, so add it if needed
  return tempObj.queryParams ? `${tempObj.path}?${tempObj.queryParams}` : tempObj.path;
}
